import { create } from "sheetly";
export let text = "dialog{border-width:var(--bs-border-width);border-radius:var(--bs-border-radius);border-color:var(--bs-border-color);box-shadow:var(--bs-box-shadow);--bs-modal-footer-gap:4px}.modal-root{min-width:240px;display:flex;flex-direction:column}.modal-content{flex-grow:1}";
export const sheet = create(text, import.meta.url);
